import i18n from "i18next";
import {ComponentProductionStatusView} from "./componentProductionStatus/ComponentProductionStatusView";
import {FrontendViewConfig} from "src/components/views/frontendViews/frontendViewConfig.ts";
import {faObjectsColumn} from "@fortawesome/pro-regular-svg-icons";

export const MELLANO_VIEWS_BY_KEYS: Record<string, FrontendViewConfig> = {
    mellanoComponentProductionStatusView: {
        component: ComponentProductionStatusView,
        displayName: i18n.t("component_production_status"),
        icon: faObjectsColumn,
        url: "/mellano/componentProductionStatus",
    },
};
